import {Outlet} from '@remix-run/react';
import {Col, Container, Row} from 'react-bootstrap';

export default function FixedWithLayout() {
  return (
    <Container>
      <Row>
        <Col>
          <Outlet />
        </Col>
      </Row>
    </Container>
  );
}

export {ReusableErrorBoundary as ErrorBoundary} from '../components/organisms/reusable-error-boundary';
